<form style="padding: 25px">
  <div class="flex flex-col xl:flex-row gap-2 justify-between">
    <span class="flex justify-start items-center text-black font-black uppercase"> Lista de Pacientes </span>
    <div class="flex justify-start lg:justify-end flex-wrap gap-2">
      <select
        class="w-60 p-2 form-select form-select-lg mr-5 text-white font-medium btn--primary"
        aria-label=".form-select-lg"
        [formControl]="ordenarControl"
      >
        <option disabled>Ordenar por</option>
        <option *ngFor="let order of listOrder" [value]="order.value">{{ order.label }}</option>
      </select>

      <div>
        <input
          [formControl]="searchControl"
          type="text"
          class="form-input w-96"
          placeholder="Pesquise por Nome, CPF ou Diagnóstico"
          aria-label="Pesquisar pacientes por nome, CPF ou diagnóstico"
        />
      </div>
      <div class="flex justify-between items-center">
        <button
          type="button"
          (click)="filtrarPacientes()"
          title="Pesquisar Pacientes"
          class="px-6 min-w-max btn btn--secondary h-35 ml-5 flex items-center gap-2"
        >
          <span>Pesquisar</span>
        </button>
        <button
          type="button"
          (click)="limparFiltros()"
          title="Recarregar lista"
          class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine flex items-center justify-center"
        >
          <img class="w-6 h-6" src="./assets/icons/refresh.svg" alt="Recarregar" />
        </button>
        <button
          type="button"
          (click)="exportarPacientesCsv()"
          title="Exportar pacientes em CSV"
          class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine flex items-center justify-center"
        >
          <img class="w-6 h-6" src="./assets/icons/download.svg" alt="Exportar CSV" />
        </button>
      </div>
    </div>
  </div>

  <app-list-pacientes
    [pacientes]="pacientes"
    [dadosPaginacao]="dadosPaginacao"
    (mudouPagina)="mudouPagina($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
  ></app-list-pacientes>
</form>
